import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, GraduationCap, HandHeart, Info, User } from "lucide-react";
import { getInfoRoles } from "../../apis/User";

const items = [
  { label: "Profile", to: "/profile", Icon: User },
  { label: "About", to: "/about", Icon: Info },
  { label: "Education", to: "/education", Icon: GraduationCap },
  { label: "Help", to: "/feed", Icon: HandHeart },
];

export default function PlatformUserMenu() {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const ref = useRef(null);

  useEffect(() => {
    getInfoRoles("", () => {}, setName);
  }, []);

  useEffect(() => {
    if (!open) return;
    const onDown = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  const initials = String(name || "?")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");

  return (
    <div ref={ref} className="platformUserMenu">
      <button
        type="button"
        className="platformUserMenu__trigger"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        <span className="platformUserMenu__avatar" aria-hidden>
          {initials || "?"}
        </span>
        <span className="platformUserMenu__text">
          <span className="platformUserMenu__hello">Hello,</span>
          <span className="platformUserMenu__name">{name || "…"}</span>
        </span>
        <ChevronDown className={`platformUserMenu__chev ${open ? "is-open" : ""}`} />
      </button>
      {open ? (
        <ul className="platformUserMenu__dropdown" role="menu">
          {items.map(({ label, to, Icon }) => (
            <li key={label} role="none">
              <Link
                role="menuitem"
                to={to}
                className="platformUserMenu__item"
                onClick={() => setOpen(false)}
              >
                <Icon className="platformUserMenu__itemIcon" aria-hidden />
                {label}
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
